var lang = {
    gen: {
        animals: {
            en: 'Animals',
            th: 'สัตว์เลี้ยง'
        },
        petfoods: {
            en: 'Petfoods',
            th: 'อาหารสัตว์เลี้ยง'
        },
        supplies: {
            en: 'Supplies',
            th: 'อุปกรณ์'
        },
        stores: {
            en: 'Stores',
            th: 'ร้านค้า'
        },
        manual:{
            en: 'Manual',
            th: 'คู่มือ'
        },
        sellWithUs: {
            en: 'Sell with us',
            th: 'เริ่มต้นร้านค้ากับเรา'
        },
        home: {
            en: 'Home',
            th: 'หน้าแรก'
        },
        goBack: {
            en: 'Back',
            th: 'ย้อนกลับ'
        },
        all: {
            en: 'All',
            th: 'ทั้งหมด'
        },
        description: {
            en: 'Description',
            th: 'รายละเอียด'
        },
        report: {
            en: 'Report',
            th: 'รายงาน'
        },
        upload: {
            en: 'Upload',
            th: 'อัพโหลด'
        },
        save: {
            en: 'Save',
            th: 'บันทึก'
        },
        close: {
            en: 'Close',
            th: 'ปิด'
        },
        cancel: {
            en: 'Cancel',
            th: 'ยกเลิก'
        },
        delete: {
            en: 'Delete',
            th: 'ลบ'
        },
        confirm: {
            en: 'Confirm',
            th: 'ยืนยัน'
        },
        continue: {
            en: 'Continue',
            th: 'ดำเนินการต่อ'
        },
        add: {
            en: 'Add',
            th: 'เพิ่ม'
        },
        edit: {
            en: 'Edit',
            th: 'แก้ไข'
        },
        loading: {
            en: 'Loading',
            th: 'กำลังโหลด'
        },
        product: {
            en: 'Product',
            th: 'สินค้า'
        },
        optional: {
            en: 'Optional',
            th: 'หากมี'
        },
        rowsPerPage: {
            en: 'Rows per page :',
            th: 'รายการต่อหน้า :'
        },
        search: {
            en: 'Search',
            th: 'ค้นหา'
        },
        or: {
            en: 'or',
            th: 'หรือ'
        },
        aboutus: {
            en: 'About us',
            th: 'เกี่ยวกับเรา'
        },
        terms: {
            en: 'Terms of use',
            th: 'ข้อกำหนดการใช้งาน'
        },
        privacy: {
            en: 'Privacy policy',
            th: 'นโยบายความเป็นส่วนตัว'
        },
        viewall: {
            en: 'View all',
            th: 'ดูทั้งหมด'
        }
    },
    userMenu: {
        sellPet: {
            en: 'Sell pet',
            th: 'เพิ่มรายการสินค้า'
        },
    },
    myAccount: {
        myProfile: {
            en: 'My Profile',
            th: 'บัญชีของฉัน'
        },
        editAccountManageYourPersonalInformation: {
            en: 'Edit Account Manage your personal information',
            th: 'แก้ไขบัญชี และ จัดการข้อมูลส่วนบุคคล'
        },
        firstname: {
            en: 'Firstname',
            th: 'ชื่อจริง'
        },
        lastname: {
            en: 'Lastname',
            th: 'นามสกุล'
        },
        displayname: {
            en: 'Displayname',
            th: 'Displayname'
        },
        birthDate: {
            en: 'Date of Birth',
            th: "วันเกิด"
        },
        gender: {
            en: 'Gender',
            th: 'เพศ'
        },
        male: {
            en: 'Male',
            th: 'ชาย'
        },
        female: {
            en: 'Female',
            th: 'หญิง'
        },
        other: {
            en: 'Other',
            th: 'อื่นๆ'
        },
    },
    createStore: {
        createStore: {
            en: 'Create Store',
            th: 'สร้างร้านค้า'
        },
        pleaseChooseYourBank: {
            en: 'Please choose your bank',
            th: 'โปรดเลือกธนาคารของคุณ'
        },
        bankAccountNumber: {
            en: 'Bank account number',
            th: 'เลขบัญชีธนาคาร'
        },
        uploadIdentityCard: {
            en: 'Upload Identity Card',
            th: 'อัพโหลดภาพบัตรประจำตัวประชาชน'
        },
        uploadBookbankImage: {
            en: 'Upload Bookbank image',
            th: 'อัพโหลดภาพหน้าสมุดบัญชีธนาคาร'
        },
        agreeWithTerms: {
            en: 'Agree with terms and conditions',
            th: 'ยอมรับเงื่อนไขและข้อตกลง'
        },
    },
    myStore: {
        myStore: {
            en: 'My Store',
            th: 'ร้านค้าของฉัน'
        },
        previewMyStore: {
            en: 'Preview My Store',
            th: 'ดูหน้าร้านค้า'
        },
        editStoreManageYourStoreInformation: {
            en: 'Edit Store, Manage your store information',
            th: 'แก้ไข และ จัดการข้อมูลร้านค้า'
        },
        storeName: {
            en: 'Store Name',
            th: 'ชื่อร้านค้า'
        },
        storeLocation: {
            en: 'Store Location',
            th: 'ที่ตั้งร้านค้า'
        },
        storeContact: {
            en: 'Store Contact',
            th: 'ช่องทางการติดต่อ'
        },
        aboutStore: {
            en: 'About Store',
            th: 'เกี่ยวกับร้านค้า'
        },
        owner: {
            en: 'Owner',
            th: 'เจ้าของร้าน'
        },
        joined: {
            en: 'Joined',
            th: 'เข้าร่วม'
        }
    },
    productList: {
        sort: {
            by: {
                en: 'Sort By',
                th: 'เรียงรายการ'
            },
            priceLowToHigh: {
                en: 'Price low to high',
                th: 'ราคาจากน้อยไปมาก'
            },
            priceHighToLow: {
                en: 'Price high to low',
                th: 'ราคาจากมากไปน้อย'
            },
            recently: {
                en: 'Recently',
                th: 'ล่าสุด'
            }
        },
    },
    productView: {
        contactStore: {
            en: 'Contact Store',
            th: 'ติดต่อร้านค้า'
        },
    },
    product: {
        productManagement: {
            en: 'Product Management',
            th: 'จัดการรายการสินค้า'
        },
        tableAction: {
            en: 'Hold|Edit|Del',
            th: ''
        },
        noDataAvailable: {
            en: 'No data available',
            th: 'ไม่มีข้อมูล'
        },
        loadingItems: {
            en: 'Loading items...',
            th: 'กำลังโหลดรายการ...'
        },
        type: {
            en: 'Type',
            th: 'หมวดหมู่ย่อย'
        },
        category: {
            en: 'Category',
            th: 'หมวดหมู่'
        },
        title: {
            en: 'Title',
            th: 'ชื่อรายการ'
        },
        image: {
            en: 'Image',
            th: ''
        },
        stock: {
            en: 'Stock',
            th: 'จำนวนในคลัง'
        },
        view: {
            en: 'View',
            th: ''
        },
        price: {
            en: 'Price',
            th: 'ราคา'
        },
        shippingPrice: {
            en: 'Shipping Price',
            th: 'ค่าจัดส่ง'
        },
        birth: {
            en: 'Birth',
            th: 'วันเกิด'
        },
        weight: {
            en: 'Weight',
            th: 'น้ำหนัก'
        },
        sex: {
            en: 'Sex',
            th: 'เพศ'
        },
        male: {
            en: 'Male',
            th: 'ผู้'
        },
        female: {
            en: 'Female',
            th: 'เมีย'
        },
        unknown: {
            en: 'Unknown',
            th: 'ไม่ระบุ'
        },
        diet: {
            en: 'Diet',
            th: 'ประเภทอาหาร'
        },
        subType: {
            en: (sub) => sub.title,
            th: (sub) => sub.titleTh || sub.title
        }
    },
    addProduct: {
        addProduct: {
            en: 'Add Product',
            th: 'เพิ่มสินค้า'
        },
        productName: {
            en: 'Product Name',
            th: 'ชื่อสินค้า'
        },
        productDescription: {
            en: 'Product Description',
            th: 'รายละเอียดสินค้า'
        },
        addImages: {
            en: (num) => `Add images (up to ${num} images),`,
            th: (num) => `เพิ่มรูป (มากสุด ${num} รูป),`
        },
        selectImage: {
            en: 'Select a preview image',
            th: 'เลือกรูปปกสินค้า'
        },
        priceAfterDiscount: {
            en: 'Price after discount',
            th: 'ราคาหลังลดแล้ว'
        },
        productPreview: {
            en: 'Product Item Preview',
            th: 'ตัวอย่างรายการสินค้า'
        }
    },
    auth: {
        login: {
            en: 'Login',
            th: 'ลงชื่อเข้าใช้'
        },
        signup: {
            en: 'Sign Up',
            th: 'สมัคร'
        },
        logout: {
            en: 'Logout',
            th: 'ออกจากระบบ'
        },
        email: {
            en: 'Email',
            th: 'อีเมล'
        },
        password: {
            en: 'Password',
            th: 'รหัสผ่าน'
        },
        forgetPassword: {
            en: 'Forgotten Password?',
            th: 'ลืมรหัสผ่าน?'
        },
        chooseNewPassword: {
            en: 'Choose your new password',
            th: 'ตั้งรหัสผ่านใหม่'
        },
        keepSignIn: {
            en: 'Keep me signed in',
            th: 'ลงชื่อเข้าใช้ค้างไว้'
        },
        agreeWithTerms: {
            en: 'I acknowledge and agree to the',
            th: 'ท่านรับทราบและตกลงตาม'
        },
        continueTo: {
            en: 'Continue to',
            th: 'เข้าสู่ระบบ'
        },
        withAccount: {
            en: 'with account',
            th: 'ด้วยบัญชีผู้ใช้'
        },
        switchAccount: {
            en: 'Switch account',
            th: 'เปลี่ยนบัญชีผู้ใช้'
        },
        backToHome: {
            en: 'Back to home',
            th: 'กลับไปหน้าหลัก'
        }
    },
    manual: {
        title: {
            en: 'Guide: How to use our platform',
            th: 'คำแนะนำการใช้งานเบื้องต้น'
        }
    },
    home: {
        title: {
            en: 'Platform for buying and selling pets and equipment',
            th: 'แพลตฟอร์มสำหรับซื้อขาย สัตว์เลี้ยง และ อุปกรณ์'
        },
        shopCategory: {
            en: 'Shop Category',
            th: 'หมวดหมู่ร้านค้า'
        },
        createStore: {
            en: 'Create shop now,',
            th: 'เปิดร้านตอนนี้เลย'
        },
        free: {
            en: `It's free`,
            th: 'ฟรี'
        },
        contestTitle1: {
            en: `Joining a contest with your litter friends is now easier than ever or choose to create your own stage to showcase other people's pets and promote yourselves!`,
            th: 'ให้การเข้าร่วมประกวดสัตว์เลี้ยงไม่ใช่เรื่องยาก'
        },
        contestTitle2: {
            en: "",
            th: 'หรือสร้างเวทีการประกวดด้วยตัวคุณเอง'
        },
        contestContact: {
            en: "If you’re interested in joining or hosting a contest contact us",
            th: 'สนใจใช้ระบบประกวดติดต่อ'
        },
        contestButton: {
            en: 'Go to contest page',
            th: 'เข้าสู่ระบบประกวดสัตว์เลี้ยง'
        }
    },
    space: {
        en: ' ',
        th: ''
    },
    location: {
        address: {
            en: 'Address',
            th: 'เลขที่'
        },
        building: {
            en: 'Building/Village',
            th: 'อาคาร/หมู่บ้าน'
        },
        soi: {
            en: 'Soi',
            th: 'ซอย'
        },
        moo: {
            en: 'Moo',
            th: 'หมู่'
        },
        road: {
            en: 'Road',
            th: 'ถนน'
        },
        subdistrict: {
            en: 'Subdistrict',
            th: 'เขต/ตำบล'
        },
        district: {
            en: 'District',
            th: 'แขวน/อำเภอ'
        },
        province: {
            en: 'Province',
            th: 'จังหวัด'
        },
        zipcode: {
            en: 'Zipcode',
            th: 'รหัสไปรษณีย์'
        },
    },
    lang: 'th'
}

export default lang;